import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CancelHttpService {
  cancelPendingRequestsValue = new Subject<void>();
  private isUserLoggingOut = false;

  constructor() { }

  setLogout(value: boolean): void {
    this.isUserLoggingOut = value;
  }

  getLogout(): boolean {
    return this.isUserLoggingOut;
  }

  /** Cancels all pending Http requests. */
  cancelPendingRequests(): void {
    this.cancelPendingRequestsValue.next();
  }

  onCancelPendingRequests(): Observable<void> {
    return this.cancelPendingRequestsValue.asObservable();
  }
}
